import { useEffect } from "react";

import { pendingRequests } from "./netActivity";

/* ------------------------------------------------------------------ *
 * The full-page cover shown while switching business.
 *
 * Switching reloads the page, so the cover has three lives: drawn over
 * the old page the moment a business is picked, redrawn by index.html
 * before the bundle loads (the sessionStorage flag survives the reload),
 * and lifted by <SwitchCoverGate/> once the new business's data is in.
 * The markup and styles live in public/index.html for that middle step.
 * ------------------------------------------------------------------ */

const KEY = "rf-switching";
const IDLE_MS = 500; // nothing in flight for this long = the page has its data
const CAP_MS = 20000; // never trap anyone behind it

export function showSwitchCover({ name, logo, monogram }) {
  const info = { name, logo: logo || "", monogram: monogram || "", at: Date.now() };
  try {
    sessionStorage.setItem(KEY, JSON.stringify(info));
  } catch (e) {
    /* private mode — the cover still shows until the reload */
  }
  if (window.__rfSwitchCover) window.__rfSwitchCover(info);
}

export function hideSwitchCover() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    /* nothing to clear */
  }
  const el = document.getElementById("rf-switch-cover");
  if (!el) return;
  el.classList.add("is-leaving");
  setTimeout(() => el.remove(), 260);
}

/* Mounted once at the root. After the reload, waits until every request
   the new business's page made has come back — and nothing new has
   started for IDLE_MS — then fades the cover out. */
export function SwitchCoverGate() {
  useEffect(() => {
    if (!document.getElementById("rf-switch-cover")) {
      try {
        sessionStorage.removeItem(KEY);
      } catch (e) {
        /* nothing to clear */
      }
      return undefined;
    }
    let idle = null;
    const check = () => {
      clearTimeout(idle);
      if (pendingRequests() === 0) idle = setTimeout(finish, IDLE_MS);
    };
    const cap = setTimeout(finish, CAP_MS);
    function stop() {
      clearTimeout(idle);
      clearTimeout(cap);
      window.removeEventListener("rf:net", check);
    }
    function finish() {
      stop();
      hideSwitchCover();
    }
    window.addEventListener("rf:net", check);
    check();
    return stop;
  }, []);
  return null;
}
